import React, {useState, useEffect, useRef} from 'react';
import Chart from "react-apexcharts";

const LineChart = () => {
    const [size, setSize] = useState({ width: 0});
    const divRef = useRef(null);


    useEffect(() => {
        const handleResize = (entries) => {
            for (let entry of entries) {
                if (entry.target === divRef.current) {
                    setSize({
                        width: entry.contentRect.width,
                    });
                }
            }
        };

        const resizeObserver = new ResizeObserver((entries) => handleResize(entries));

        if (divRef.current) {
            resizeObserver.observe(divRef.current);
        }

        return () => {
            if (divRef.current) {
                resizeObserver.unobserve(divRef.current);
            }
        };
    }, []);

    const options = {
        chart: {
            id: "basic-bar"
        },
        xaxis: {
            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
        },
        stroke: {
            curve: "smooth",
        }
    }
    const series = [
        {
            name: "series-1",
            data: [30, 40, 45, 50, 49, 60, 70, 91]
        },
        {
            name: "series-5",
            data: [60, 50, 35, 40, 75, 20, 45, 91]
        }
    ]

    return (
        <div className="card">
            <div className="card-body" ref={divRef}>
                <Chart
                    options={options}
                    series={series}
                    type="line"
                    width={size.width}
                />
            </div>
        </div>
    );
};

export default LineChart;